// Core
import { Text, Flex } from '@chakra-ui/react';

// Components
import { CheckIcon, CheckWhiteIcon, CheckActiveIcon} from 'components/Icons/Icons';

const MembershipPrivilegeItem = ({ title, description, isPopular, isDark }) => {
    return (
    	<Flex gap="8px" mb="10px">
    		{ !isPopular ? isDark ? <CheckIcon fontSize="20px" /> : <CheckWhiteIcon fontSize="20px" /> : (<CheckActiveIcon fontSize="20px" />) }
			<Text><span style={{ 
				color: '#099BFF', 
				fontWeight: '600', 
				fontStyle: 'italic' }}>{title}</span> {description}</Text>
		</Flex>
	);
};

export default MembershipPrivilegeItem;